import Vue from 'vue'
import Vuex from 'vuex'

import auth from './auth/store'
import campaign from './campaign/store'
import data from './data/store'
import game from './game/store'
import gameData from './gameData/store'
import gameLobby from './gameLobby/store'
import gameOwner from './gameOwner/store'
import gameTemplate from './gameTemplate/store'
import loader from './loader/store'
import product from './product/store'
import team from './team/store'
import userAccount from './userAccount/store'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

const devMode = process.env.NODE_ENV === 'development';

const modules = {
  auth,
  campaign,
  data,
  game,
  gameData,
  gameLobby,
  gameOwner,
  gameTemplate,
  loader,
  product,
  team,
  userAccount
}

const store = new Vuex.Store({
  modules,
  plugins: devMode ? [createLogger({
    collapsed: false, // auto-expand logged mutations
    logActions: false, // Log Actions
    logMutations: true, // Log mutations
    logger: console, // implementation of the `console` API, default `console`
  })] : []
})

store.clearState = (clear = []) => {
  const newState = {}
  clear.forEach(name => {
    const defaultState = modules[name].defaultState
    if (defaultState) {
      newState[name] = defaultState()
    }
  })
  store.replaceState({ ...store.state, ...newState })
}

store.clearGameState = () => {
  store.clearState(['campaign', 'data', 'game', 'gameData', 'gameLobby'])
}

export default store
